import * as React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { SettlementType } from "@/models/billingPaymentSchedule";
import { BillingPaymentScheduleConstants } from "./BillingPaymentScheduleConstants";
import { EVENT_COLORS, buildLegendItems } from "./BillingPaymentScheduleEvents";

export type BillingPaymentScheduleLegendProps = {
  settlementType: SettlementType | null;
};

export const BillingPaymentScheduleLegend: React.FC<
  BillingPaymentScheduleLegendProps
> = ({ settlementType }) => {
  const items = buildLegendItems(settlementType);

  return (
    <Paper sx={{ p: 2, mt: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        {BillingPaymentScheduleConstants.Legend}
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
        {items.map((item) => (
          <Box key={item.type} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box
              sx={{
                px: 0.75,
                py: 0.25,
                borderRadius: "2px",
                fontSize: "0.7rem",
                lineHeight: 1.4,
                whiteSpace: "nowrap",
                backgroundColor: EVENT_COLORS[item.type].background,
                color: EVENT_COLORS[item.type].text,
              }}
            >
              {item.abbr}
            </Box>
            <Typography variant="body2">{item.label}</Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};
